/**
 * Created by Arif Topcu in 2019
 */

import React, { memo, useCallback } from "react";
import ComplicationSelector from "@ls/grouping-complication-selector";
import { useDispatch, useSelector } from "react-redux";
import BookAnalyticDefinition from "state/bookAnalytics/BookAnalyticDefinition";
import { setDefinition as setBookAnalyticDefinition } from "state/bookAnalytics/actions";
import { selectDefinitions } from "state/bookAnalytics/selectors";
import SelectionState from "state/selections/SelectionState";
import BookAnalyticsSelectorComplication from "./BookAnalyticsSelectorComplication";

const BookAnalyticsSelector = () => {
  const dispatch = useDispatch();
  const definitions = useSelector(
    selectDefinitions(SelectionState.UNCOMMITTED)
  );
  const setDefinition = useCallback(
    (definitions, idx) => dispatch(setBookAnalyticDefinition(definitions, idx)),
    [dispatch]
  );

  return (
    <ComplicationSelector
      selectedDefinitions={definitions}
      setDefinition={setDefinition}
      getDefaultDefinition={BookAnalyticDefinition.getDefault}
      ComplicationComponent={BookAnalyticsSelectorComplication}
      btnTitle={"Book Analytics"}
      addMoreText={"Book Analytic Column"}
    />
  );
};

export default memo(BookAnalyticsSelector);
